module.exports = __webpack_public_path__ + "static/media/webdesign-services-img6.53b5c8af.jpg";